
/*
Defines the custom element <ravel-sequence>
*/

import { RavelSequence } from './src/RavelSequence.js';

customElements.define('ravel-sequence', RavelSequence);
